import firebase from 'firebase'
import _ from 'lodash'
import moment from 'moment'

const GeoFire = require('geofire')

const {map} = require('p-iteration')

import '../../settings'

const app = firebase.initializeApp(ENV.firebase)
const auth = app.auth()
const database = app.database()

const geoRef = database.ref('realestate_locations')
const geoFire = new GeoFire(geoRef)

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

// GEOHASH METHODS

let BITS = [16, 8, 4, 2, 1]

let BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz'
let NEIGHBORS = {
    right: {even: 'bc01fg45238967deuvhjyznpkmstqrwx'},
    left: {even: '238967debc01fg45kmstqrwxuvhjyznp'},
    top: {even: 'p0r21436x8zb9dcf5h7kjnmqesgutwvy'},
    bottom: {even: '14365h7k9dcfesgujnmqp0r2twvyx8zb'}
}
let BORDERS = {
    right: {even: 'bcfguvyz'},
    left: {even: '0145hjnp'},
    top: {even: 'prxz'},
    bottom: {even: '028b'}
}

NEIGHBORS.bottom.odd = NEIGHBORS.left.even
NEIGHBORS.top.odd = NEIGHBORS.right.even
NEIGHBORS.left.odd = NEIGHBORS.bottom.even
NEIGHBORS.right.odd = NEIGHBORS.top.even

BORDERS.bottom.odd = BORDERS.left.even
BORDERS.top.odd = BORDERS.right.even
BORDERS.left.odd = BORDERS.bottom.even
BORDERS.right.odd = BORDERS.top.even

function refine_interval (interval, cd, mask) {
    if (cd & mask)
        interval[0] = (interval[0] + interval[1]) / 2
    else
        interval[1] = (interval[0] + interval[1]) / 2
}

function calculateAdjacent (srcHash, dir) {
    srcHash = srcHash.toLowerCase()
    let lastChr = srcHash.charAt(srcHash.length - 1)
    let type = (srcHash.length % 2) ? 'odd' : 'even'
    let base = srcHash.substring(0, srcHash.length - 1)
    if (BORDERS[dir][type].indexOf(lastChr) !== -1)
        base = calculateAdjacent(base, dir)
    return base + BASE32[NEIGHBORS[dir][type].indexOf(lastChr)]
}

function decodeGeoHash (geohash) {
    let is_even = 1
    let lat = []
    let lon = []
    lat[0] = -90.0
    lat[1] = 90.0
    lon[0] = -180.0
    lon[1] = 180.0
    let lat_err = 90.0
    let lon_err = 180.0

    for (i = 0; i < geohash.length; i++) {
        c = geohash[i]
        cd = BASE32.indexOf(c)
        for (j = 0; j < 5; j++) {
            mask = BITS[j]
            if (is_even) {
                lon_err /= 2
                refine_interval(lon, cd, mask)
            } else {
                lat_err /= 2
                refine_interval(lat, cd, mask)
            }
            is_even = !is_even
        }
    }
    lat[2] = (lat[0] + lat[1]) / 2
    lon[2] = (lon[0] + lon[1]) / 2

    return {latitude: lat, longitude: lon}
}

function encodeGeoHash (latitude, longitude) {
    let is_even = 1
    let i = 0
    let lat = []
    let lon = []
    let bit = 0
    let ch = 0
    let precision = 12
    let geohash = ''

    lat[0] = -90.0
    lat[1] = 90.0
    lon[0] = -180.0
    lon[1] = 180.0

    while (geohash.length < precision) {
        if (is_even) {
            let mid = (lon[0] + lon[1]) / 2
            if (longitude > mid) {
                ch |= BITS[bit]
                lon[0] = mid
            } else
                lon[1] = mid
        } else {
            let mid = (lat[0] + lat[1]) / 2
            if (latitude > mid) {
                ch |= BITS[bit]
                lat[0] = mid
            } else
                lat[1] = mid
        }

        is_even = !is_even
        if (bit < 4)
            bit++
        else {
            geohash += BASE32[ch]
            bit = 0
            ch = 0
        }
    }
    return geohash
}

// END OF GEOHASH METHODS

export default {

    set_new (data) {
        console.log('--- api.js set_new')
        console.log('data: ')
        console.log(data)
        console.log('----------')

        return new Promise((resolve, reject) => {
            const dateCreated = moment().valueOf()
            const object = {
                date_created: dateCreated,
                date_modified: dateCreated
            }
            const ref = database.ref(data.path + data.key)
            return ref.set(object)
                .then(res => resolve({
                    key: data.key,
                    date_created: dateCreated,
                    date_modified: dateCreated,
                    path: data.path
                }))
        })
    },
    set_value (data) {

        console.log('--- api.js set_value')
        console.log('path: ')
        console.log(data.path)
        console.log('value: ')
        console.log(data.value)
        console.log('----------')

        return new Promise((resolve, reject) => {
            const ref = database.ref(data.path)
            const dateModified = moment().valueOf()
            /*if(data.save_timestamp === true){
             data.object['date_modified'] = dateModified
             }*/
            return ref.set(data.value)
                .then(res => resolve({date_modified: dateModified})).catch(err => {
                    reject()
                    console.log('error catched...')
                    console.log(err)
                })
        })
    },
    update (data) {
        console.log('--- api.js update')
        console.log('path: ')
        console.log(data.path)
        console.log('object: ')
        console.log(data.object)
        console.log('----------')
        return new Promise((resolve, reject) => {
            const ref = database.ref(data.path)
            const dateModified = moment().valueOf()
            if (data.save_timestamp === true) {
                data.object.date_modified = dateModified
            }
            return ref.update(data.object)
                .then(res => resolve({date_modified: dateModified})).catch(err => {
                    reject()
                    console.log('error catched...')
                    console.log(err)
                })
        })
    },
    create (data) {
        console.log('--- api.js create')
        console.log('path: ')
        console.log(data.path)
        console.log('----------')
        return new Promise((resolve, reject) => {
            const dateCreated = moment().valueOf()
            const object = {
                date_created: dateCreated,
                date_modified: dateCreated,
                path: check_undefined(data.path),
                parent_path: check_undefined(data.parent_path)
            }
            const ref = database.ref(data.path)
            return ref.push(object)
                .then(res => resolve(
                    {
                        key: res.key,
                        date_created: dateCreated,
                        date_modified: dateCreated,
                        path: check_undefined(data.path),
                        parent_path: check_undefined(data.parent_path)
                    })).catch(err => {
                    reject()
                    console.log('error catched...')
                    console.log(err)
                })
        })
    },
    delete (data) {
        console.log('--- api.js delete')
        console.log('path: ')
        console.log(data.path)
        console.log('----------')
        return new Promise((resolve, reject) => {
            const ref = database.ref(data.path)
            const dateModified = moment().valueOf()
            return ref.remove()
                .then(res => resolve(
                    {date_modified: dateModified})).catch(err => {
                    reject()
                    console.log('error catched...')
                    console.log(err)
                })
        })
    },
    queryGeohash (data) {
        console.log('--- api.js queryGeohash')
        console.log('radius: ')
        console.log(data.distance_km)
        console.log('lat: ')
        console.log(data.lat)
        console.log('lng: ')
        console.log(data.lng)
        console.log('----------')

        /*
         return new Promise((resolve, reject) => {
         geoFire.query({
         center: [data.lat, data.lng],
         radius: data.distance_km
         }).then(function() {
         console.log("Query has been done to GeoFire")
         resolve()
         }, function(error) {
         console.log("Error: " + error)
         reject()
         })
         })
         */

        const querytest = geoFire.query({
            center: [data.lat, data.lng],
            radius: data.distance_km
        })

        querytest.on('key_entered', function (key, location, distance) {
            console.log(key + ' is located at [' + location + '] which is within the query (' + distance.toFixed(2) + ' km from center)')
        })
    },
    getGeohash (data) {
        console.log('--- api.js setGeohash')
        console.log('key: ')
        console.log(data.key)
        console.log('lat: ')
        console.log(data.lat)
        console.log('lng: ')
        console.log(data.lng)
        console.log('----------')

        return new Promise((resolve, reject) => {

            const geohash = encodeGeoHash(data.lat, data.lng)
            resolve({geohash: geohash})

            /*
             geoFire.set(data.key, [data.lat, data.lng]).then(function () {
             console.log('Provided key has been added to GeoFire')
             resolve()
             }, function (error) {
             console.log('Error: ' + error)
             reject()
             })
             */

        })
    },
    logIn (email, password) {
        return auth.signInWithEmailAndPassword(email, password)
    },

    logOut () {
        return auth.signOut()
    },

    signUp (email, password) {
        return auth.createUserWithEmailAndPassword(email, password)
    },

    initNotesForUserId (userId) {
        const vm = this
        return new Promise((resolve, reject) => {
            return this.getDefaultNotes()
                .then(notes => {
                    const dateModified = moment().toString()
                    _.forEach(notes, function (note, key) {
                        note.date_modified = dateModified
                        note.date_created = dateModified
                        vm.createNote(userId, note)
                    })
                    vm.updateTheme(userId, 'light')
                    vm.updateRole(userId, 'guest')
                    resolve(true)
                })
        })
    },

    get (data) {
        console.log('--- api.js get')
        console.log('path: ')
        console.log(data.path)
        console.log('----------')
        return new Promise((resolve, reject) => {
            const ref = database.ref(data.path)
            return ref.once('value')
                .then(res => resolve(res.val()))
        })
    },

    getAllChildren (data) {
        console.log('--- api.js getAllChildren')
        console.log('path: ')
        console.log(data.path)
        console.log('----------')

        let all_children = []

        return new Promise((resolve, reject) => {
            const ref = database.ref(data.path)
            return ref.once('value').then(function (snapshot) {

                snapshot.forEach(function (childSnapshot) {
                    //Here you can access  childSnapshot.key

                    all_children.push(childSnapshot.val())

                }).then(res => resolve({all_children: all_children}))

            })

        })
    },

    getContacts () {
        return new Promise((resolve, reject) => {
            const contactsRef = database.ref('contacts')
            return contactsRef.once('value')
                .then(res => resolve(res.val()))
        })
    },

    getDefaultNotes () {
        return new Promise((resolve, reject) => {
            const notesRef = database.ref('default_notes/notes')
            return notesRef.once('value')
                .then(res => resolve(res.val()))
        })
    },

    getAppraisalIdsForUserId (userId) {
        return new Promise((resolve, reject) => {
            const userRef = database.ref(`users/${userId}/appraisals`)
            return userRef.once('value')
                .then(res => resolve(res.val()))
        })
    },

    getAppraisal () {
        return new Promise((resolve, reject) => {
            const userRef = database.ref(`appraisals`)
            return userRef.once('value')
                .then(res => resolve(res.val()))
        })
    },

    getUserRole (userId) {
        return new Promise((resolve, reject) => {
            const rolesRef = database.ref(`users/${userId}/roles`)
            return rolesRef.once('value')
                .then(res => resolve(res.val()))
        })
    },

    getDataForUserId (userId) {
        return new Promise((resolve, reject) => {
            const userRef = database.ref(`users/${userId}`)
            return userRef.once('value')
                .then(res => resolve(res.val()))
        })
    },

    getValuationPrices () {
        return new Promise((resolve, reject) => {
            const valuationPricesRef = database.ref('valuation_prices')
            return valuationPricesRef.once('value')
                .then(res => resolve(res.val()))
        })
    },

    getPreviewData () {
        return new Promise((resolve, reject) => {
            const notesRef = database.ref('default_notes/notes')
            return notesRef.once('value')
                .then((res) => {
                    const notes = {}
                    const dateModified = moment().subtract(1, 'minute').toString()
                    res.val().forEach((note) => {
                        note.date_modified = dateModified
                        notes[note.id] = note
                    })
                    resolve({notes: notes, theme: 'light'})
                })
        })
    },

    createNote (userId, note) {
        return new Promise((resolve, reject) => {
            const userNotesRef = database.ref(`users/${userId}/notes`)
            return userNotesRef.push(note)
                .then(res => resolve(res.key))
        })
    },

    updateBudgetRequest (data) {
        return new Promise((resolve, reject) => {
            const budgetRef = database.ref(`budgetrequests`)
            const timestamp = moment().valueOf()
            return budgetRef.push({
                petitioner_name: data.petitioner_name,
                petitioner_surnames: data.petitioner_surnames,
                petitioner_company: data.petitioner_company,
                petitioner_email: data.petitioner_email,
                petitioner_telephone: data.petitioner_telephone,
                property_type: data.property_type,
                property_address: data.property_address,
                property_postal_code: data.property_postal_code,
                property_municipality: data.property_municipality,
                property_province: data.property_province,
                property_area: data.property_area,
                property_cadastral_reference: data.property_cadastral_reference,
                property_appraisal_purpose: data.property_appraisal_purpose,
                property_notes: data.property_notes,
                timestamp: timestamp
            })
                .then(res => resolve({data: data, timestamp: timestamp}))
        })
    },

    updateNote (userId, key, note) {
        return new Promise((resolve, reject) => {
            const notesRef = database.ref(`users/${userId}/notes/${key}`)
            const dateModified = moment().toString()
            return notesRef.update({
                name: note.name,
                body: note.body,
                date_modified: dateModified
            })
                .then(res => resolve({key: key, date_modified: dateModified}))
        })
    },

    deleteNote (userId, key) {
        const notesRef = database.ref(`users/${userId}/notes/${key}`)
        return notesRef.remove()
    },

    updateLanguage (userId, language) {
        return new Promise((resolve, reject) => {
            const userRef = database.ref(`users/${userId}`)
            return userRef.update({language: language})
                .then(res => resolve(language))
        })
    },

    updateTheme (userId, theme) {
        return new Promise((resolve, reject) => {
            const userRef = database.ref(`users/${userId}`)
            return userRef.update({theme: theme})
                .then(res => resolve(theme))
        })
    },

    updateRole (userId, role) {
        return new Promise((resolve, reject) => {
            const userRef = database.ref(`users/${userId}`)
            return userRef.update({role: role})
                .then(res => resolve(role))
        })
    },

    updateUserInitialData (userId, data) {
        return new Promise((resolve, reject) => {
            const userRef = database.ref(`users/${userId}`)
            return userRef.update({name: data.name, surnames: data.surnames, company: data.company})
                .then(res => resolve(data))
        })
    },

    getPublicNoteForId (noteId) {
        return new Promise((resolve, reject) => {
            const noteRef = database.ref(`public_notes/${noteId}`)
            return noteRef.on('value', (snapshot) => {
                const data = snapshot.val()
                if (data) {
                    const notesRef = database.ref(`users/${data.user_id}/notes/${data.note_id}`)
                    notesRef.on('value', (snapshot) => {
                        const note = snapshot.val()
                        resolve(note)
                    })
                } else {
                    reject('Nothing here.')
                }
            })
        })
    },

    toggleIsPublic (userId, key, note) {
        const is_public = !note.is_public
        return new Promise((resolve, reject) => {
            const notesRef = database.ref(`users/${userId}/notes/${key}`)
            return notesRef.update({
                is_public: is_public,
            })
                .then(res => {
                    const publicNoteRef = database.ref(`public_notes/${key}`)
                    if (is_public) {
                        publicNoteRef.set({
                            user_id: userId,
                            note_id: key
                        })
                    } else {
                        publicNoteRef.remove()
                    }
                    resolve({key: key, is_public: is_public})
                })
        })
    },
    deleteImage (data) {
        return new Promise((resolve, reject) => {
            let path = data.path
            let filename = data.filename
            console.log('--> delete Photograph')
            console.log('path: ' + path)

            // Get a reference to the storage service, which is used to create references in your storage bucket
            let storage = firebase.storage()
            // Create a storage reference from our storage service
            let storageRef = storage.ref()
            // Create a reference to the file to delete
            let imageRef = storageRef.child(path + filename)

            // Delete the file
            imageRef.delete().then(function () {
                // File deleted successfully
                resolve()
            }).catch(function (error) {
                // Uh-oh, an error occurred!
                reject()
            })

        })
    },
    uploadImages (data) {
        return new Promise((resolve, reject) => {
            let path = data.path
            let files = data.files
            let storageRef = firebase.storage().ref(path)

            let inCreate = function (data) {
                return new Promise((resolve, reject) => {
                    const dateCreated = moment().valueOf()
                    const object = {
                        date_created: dateCreated,
                        date_modified: dateCreated,
                        path: check_undefined(data.path),
                        parent_path: check_undefined(data.parent_path)
                    }
                    const ref = database.ref(data.path)
                    return ref.push(object)
                        .then(res => resolve(
                            {
                                key: res.key,
                                date_created: dateCreated,
                                date_modified: dateCreated,
                                path: check_undefined(data.path),
                                parent_path: check_undefined(data.parent_path)
                            })).catch(err => {
                            reject()
                            console.log('error catched...')
                            console.log(err)
                        })
                })
            }

            let inSetValue = function (data) {
                console.log('--- api.js set_value')
                console.log('path: ')
                console.log(data.path)
                console.log('value: ')
                console.log(data.value)
                console.log('----------')

                return new Promise((resolve, reject) => {
                    const ref = database.ref(data.path)
                    const dateModified = moment().valueOf()
                    /*if(data.save_timestamp === true){
                     data.object['date_modified'] = dateModified
                     }*/
                    return ref.set(data.value)
                        .then(res => resolve({date_modified: dateModified})).catch(err => {
                            reject()
                            console.log('error catched...')
                            console.log(err)
                        })
                })
            }

            let isImage = function (file) {
                return file['type'].split('/')[0] === 'image'
                //returns true or false
            }

            let uploadFile = function (file) {

                return new Promise((resolve, reject) => {
                    if (isImage(file)) {

                        inCreate({path: data.path}).then(res => {
                            // console.log(res)
                            let key = res.key
                            let date_created = res.date_created
                            let date_modified = res.date_modified
                            let path = res.path

                            inSetValue({
                                path: data.path + key + '/' + 'id',
                                value: key
                            }).then(res => {
                                inSetValue({
                                    path: data.path + key + '/' + 'filename',
                                    value: file.name
                                }).then(res => {
                                    inSetValue({
                                        path: data.path + key + '/' + 'date_created',
                                        value: date_created
                                    }).then(res => {
                                        inSetValue({
                                            path: data.path + key + '/' + 'date_modified',
                                            value: date_modified
                                        }).then(res => {
                                            inSetValue({
                                                path: data.path + key + '/' + 'path',
                                                value: path
                                            }).then(res => {

                                                let thisRef = storageRef.child(key + '/' + file.name)
                                                return thisRef.put(file).then(function (snapshot) {
                                                    console.log('Uploaded a blob or file!')
                                                }).then(function (result) {
                                                    //get request to get URL for uploaded file
                                                    thisRef.getDownloadURL().then(function (url) {
                                                        console.log(url)


                                                        inSetValue({
                                                            path: data.path + key + '/' + 'url',
                                                            value: url
                                                        }).then(res => {

                                                            resolve()

                                                        })
                                                    })

                                                })

                                            })
                                        })

                                    })
                                })
                            })

                        })
                    } else {
                        alert('L\'arxiu "' + file.name + '" no és una imatge! No s\'ha carregat. Només s\'accepten arxius en format imatge')
                    }

                })
            }

            /*
                return Promise.all(filesArray.map(function (file) {

                    if (isImage(file)) {
                        let thisRef = storageRef.child(file.name)
                        return thisRef.put(file).then(function (snapshot) {
                            console.log('Uploaded a blob or file!')
                        }).then(function (result) {
                            //get request to get URL for uploaded file
                            thisRef.getDownloadURL().then(function (url) {
                                console.log(url)
                                inCreate({path: 'realestate_appraisals/' + data.path}).then(res => {
                                    // console.log(res)
                                    let key = res.key
                                    let date_created = res.date_created
                                    let date_modified = res.date_modified
                                    let path = res.path

                                    inSetValue({
                                        path: 'realestate_appraisals/' + data.path + key + '/' + 'url',
                                        value: url
                                    }).then(res => {
                                        inSetValue({
                                            path: 'realestate_appraisals/' + data.path + key + '/' + 'id',
                                            value: key
                                        }).then(res => {
                                            inSetValue({
                                                path: 'realestate_appraisals/' + data.path + key + '/' + 'filename',
                                                value: file.name
                                            }).then(res => {
                                                inSetValue({
                                                    path: 'realestate_appraisals/' + data.path + key + '/' + 'date_created',
                                                    value: date_created
                                                }).then(res => {
                                                    inSetValue({
                                                        path: 'realestate_appraisals/' + data.path + key + '/' + 'date_modified',
                                                        value: date_modified
                                                    }).then(res => {
                                                        inSetValue({
                                                            path: 'realestate_appraisals/' + data.path + key + '/' + 'path',
                                                            value: path
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    } else {
                        alert('L\'arxiu "' + file.name + '" no és una imatge! No s\'ha carregat. Només s\'accepten arxius en format imatge')
                    }

                }))
                */

            // set it up
            storageRef.constructor.prototype.putFiles = function (files) {
                let ref = this
                const filesArray = [...files]
                return new Promise((resolve, reject) => {
                    map(filesArray, (file) => uploadFile(file)
                        .then((result) => {

                            resolve()
                        }))
                })
            }

            // use it!
            storageRef.putFiles(files).then(function (metadatas) {
                // Get an array of file metadata
                resolve()
            }).catch(function (error) {
                // If any task fails, handle this
                reject()
            })
        })
    }

}



// WEBPACK FOOTER //
// ./src/store/api.js